import React, {useState, useEffect, useMemo} from 'react';
import { useTable, useSortBy } from 'react-table';
import {ChainSorter} from 'chainsorter';
import convert from 'convert-units';
import Table from '../ui/Table.js';
import ModifyForm from './modify.js';
import Box from '../ui/Box.js';

import {callback, usePrevious} from '../../helpers.js';
import api from '../../api/index.js';


export default (props) => {
	
	const [data, setData] = useState(false);
	const [massUnits, setMassUnits] = useState('kg');
	const [selected, setSelected] = useState(false);
	const [interfaceOpen, setInterfaceOpen] = useState(false);
	
	const refresh = async () => {
		// Hit the API
		try {
			let d = await api.get('attendance?date=' + props.date.api());
			console.log(d);
			d = ChainSorter(d).custom((a,b) => {
				if (a.Employee.FirstName > b.Employee.FirstName)
					return 1;
				if (a.Employee.FirstName < b.Employee.FirstName)
					return -1;
				if (a.Employee.LastName > b.Employee.LastName)
					return 1;
				if (a.Employee.LastName < b.Employee.LastName)
					return -1;
				return 0;
			}).sort()
			console.log(d);
			setData(d);
			setSelected(false);
			setMassUnits(await api.settings.get('display_units_mass'));
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	
	const closeInterface = (e) => {
		setInterfaceOpen(false);
	}
	
	const onChanged = (e) => {
		// Close interface
		// Refresh
	}
	
	
	const tabledata = useMemo(() => {
		console.log("Computing memo with", data);
		let td = [];
		for(let i=0; i < data.length; i++) {
			let rd = data[i];
			let rateunittype = ''; // We should find a more abstract way to do this...
			switch(rd['RateTypeID']) {
				case 1: // hourly
					break;
				case 3: // Blueberry hand pick
					rateunittype = 'kg'; // If it's this, we should convert it
					break;
				case 4: // Raspberry piece rate
					rateunittype = 'Dollars';
					break;
			}
			
			let amount = rd['data']['amount']
			if (rateunittype == 'kg') {
				const precision = Math.pow(10, props.precision || 2);
				amount = Math.round(convert(amount).from('kg').to(massUnits) * precision)/precision;
				rateunittype = massUnits;
				console.log("rut", rateunittype);
			}
			
			if (rateunittype == 'Dollars')
				amount = '$' + amount;
			
			td.push({
				firstName: rd['Employee']['FirstName'],
				lastName: rd['Employee']['LastName'],
				taskName: rd['TaskName'],
				taskAmount: amount,
				rateUnitType: rateunittype,
				hours: rd['Hours'],
				farmName: rd['Farm']['FarmName'],
				fieldNumber: rd['Field']['FieldNumber'],
				attendanceId: rd['AttendanceID']
			});
		}
		//console.log(td);
		return td;
	}, [data, massUnits]);
	
	
	const columns = React.useMemo(() => [
		{
			Header: 'Who',
			columns: [
			{
				Header: 'First',
				accessor: 'firstName',
			},
			{
				Header: 'Last',
				accessor: 'lastName',
			},
			],
		},
		{
			Header: 'Did what',
			columns: [
				{
					Header: 'Task',
					accessor: 'taskName',
				},
				{
					Header: 'Amount',
					accessor: 'taskAmount',
				},
				{
					Header: 'Units',
					accessor: 'rateUnitType',
				},
			],
		},
		{
			Header: 'For how long',
			columns: [
				{
					Header: 'Hours',
					accessor: 'hours'
				}
			]
		},
		{
			Header: 'And where',
			columns: [
				{
					Header: 'Farm',
					accessor: 'farmName'
				},
				{
					Header: 'Field',
					accessor: 'fieldNumber'
				}
			]
		}
	],[])
	
	const prevProps = usePrevious(props);
	useEffect(()=>{
		if (data === false || prevProps.date != props.date || prevProps.reloadKey != props.reloadKey) {
			refresh();
		}
	});
	
	
	const editOne = (d) => {
		console.log("Should edit", d);
		for(let i=0; i < data.length; i++) {
			console.log("comparing", data[i], d);
			if (data[i]['AttendanceID'] == d['attendanceId']) {
				setSelected(data[i]);
				setInterfaceOpen(true);
				break;
			}
		}
	}
	
	const onUpdated = (e) => {
		setInterfaceOpen(false);
		refresh();
	}
	
	return <>
		<Table columns={columns} data={tabledata} onClick={editOne}/>
		<Box modal={true} isOpen={interfaceOpen} onRequestClose={closeInterface} title="Modify attendance record">
		<ModifyForm data={selected} onUpdated={onUpdated} />
		</Box>
	</>
}